import React from 'react';

import { Routes, Route } from 'react-router-dom';

import { PageError } from '../../../layout';
import { AuthById } from '../AuthById';

import { Login } from './Login';
import { Register } from './Register';

export const OpenId = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path=":id/*" element={<AuthById />} />
      <Route
        path="*"
        element={
          <div>
            <PageError status={404} />
          </div>
        }
      />
    </Routes>
  );
};
